import '@css/style.scss';
import posthog from 'posthog-js';

import App from '@js/App';
import LocaleSwitcher from '@js/components/LocaleSwitcher';
import Nav from '@js/components/Nav';
import Page from '@js/components/Page';
import Carousel from '@js/components/Carousel';
import Tabs from '@js/components/Tabs';
import TextSplit from '@js/components/TextSplit';
import Tour from '@js/components/Tour';

window.addEventListener('DOMContentLoaded', () => {
    window.__APP__ = new App([
        {
            component: Carousel,
            name: 'carousel',
        },
        {
            component: LocaleSwitcher,
            name: 'langSwitcher',
        },
        {
            component: Nav,
            name: 'nav',
        },
        {
            component: Page,
            name: 'page',
        },
        {
            component: Tabs,
            name: 'tabs',
        },
        {
            component: TextSplit,
            name: 'textSplit',
        },
        {
            component: Tour,
            name: 'tour',
        },
    ]);
});

// PostHog
posthog.init('phc_oEcXASpySzkgooWATEqYZpBhWNLn8c1cCTuhuEQaho', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
});

// Vite HMR
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}
